import { Left, Logout, Right } from "assets/Icon";
import {
  Button,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  styled,
  useTheme,
} from "@mui/material";

import { useSelector } from "react-redux";
import { useState } from "react";

function UserOptions({
  setOpenLogout,
}) {
  const theme = useTheme();

  const user = useSelector((state) => state.user?.user?.data);

  const [open, setOpen] = useState(false);

  const handleClick = (event) => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <ButtonStyle
        id="basic-ButtonStyle"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        variant="text"
        color="text"
      >
        {open ? (
          <Right color={theme.palette.text.main} />
        ) : (
          <Left color={theme.palette.text.main} />
        )}
        {user?.userName || "-"}
      </ButtonStyle>

      <Drawer anchor="right" open={open} onClose={handleClose}>
        <ListStyle>
          <ListItemStyle>
            <ListItemButtonStyle
              onClick={() => {
                setOpenLogout(true);
                handleClose();
              }}
            >
              <ListItemIcon>
                <Logout color={theme.palette.text.main} />
              </ListItemIcon>
              <ListItemText primary="خروج" />
            </ListItemButtonStyle>
          </ListItemStyle>
        </ListStyle>
      </Drawer>
    </>
  );
}

const ButtonStyle = styled(Button)(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",

  svg: {
    marginRight: theme.spacing(1),
  },
}));

const ListItemStyle = styled(ListItem)(({ theme }) => ({
  padding: theme.spacing(0.5, 1),

  "&:hover": {
    background: theme.palette.background.blueReverseGradient,
  },
}));

const ListStyle = styled(List)(({ theme }) => ({
  minWidth: "300px",
  padding: 0,
}));

const ListItemButtonStyle = styled(ListItemButton)(({ theme }) => ({
  flexDirection: "row-reverse",
  padding: theme.spacing(0.5, 1),
  borderRadius: "5px",

  ".MuiListItemIcon-root": {
    minWidth: "35px",
    justifyContent: "flex-end",
    color: theme.palette.common.white,
  },

  ".MuiListItemText-root": {
    textAlign: "right",
  },
}));

export default UserOptions;
